import { createAction, props } from '@ngrx/store';
import { Form } from '../../../domain/form.interface';

export const loadVersionsList = createAction(
  '[VERSION] Load Versions List',
  props<{ formId: string }>()
);

export const loadVersionsListSuccess = createAction(
  '[VERSION] Load Versions List Success',
  props<{ data: any }>()
);

export const loadVersionsListFailure = createAction(
  '[VERSION] Load Versions List Failure',
  props<{ error: any }>()
);

export const getSelectedVersion = createAction(
  '[VERSION] Get Selected Version',
  props<{ formId: string, version: Form }>()
);

export const getSelectedVersionSuccess = createAction(
  '[VERSION] Get Selected Version Success',
  props<{ version: Form }>()
);

export const getSelectedVersionFailure = createAction(
  '[VERSION] Get Selected Version Failure',
  props<{ error: string }>()
);

export const deleteVersion = createAction(
  '[VERSION] Delete Version',
  props<{ formId: string, version: Form }>()
);

export const deleteVersionSuccess = createAction(
  '[VERSION] Delete Version Success',
  props<{ pk: string; sk: string }>()
);

export const deleteVersionFailure = createAction(
  '[VERSION] Delete Versions Failure',
  props<{ error: any }>()
);

export const addVersion = createAction(
  '[VERSION] Add Version',
  props<{ formId: string }>()
);

export const addVersionSuccess = createAction(
  '[VERSION] Add Versions Success',
  props<{ version: Form }>()
);

export const addVersionFailure = createAction(
  '[VERSION] Add Version Failure',
  props<{ error: any }>()
);

export const editVersion = createAction(
  '[VERSION] Edit Version',
  props<{ formId: string, version: Form }>()
);

export const editVersionSuccess = createAction(
  '[VERSION] Edit Versions Success',
  props<{ version: Form }>()
);
export const editVersionFailure = createAction(
  '[VERSION] Edit Versions Failure',
  props<{ error: any }>()
);